import { Component, ViewChild } from '@angular/core';
import { Dashboards } from '../../models/dashboards';
import { DashboardsService } from '../../services/dashboards.service';
import { Table, TableModule } from 'primeng/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, RouterLink } from '@angular/router';
import { catchError, combineLatest, map, Observable, of, shareReplay } from 'rxjs';
import { MainHeaderComponent } from '../../components/shared/main-header/main-header.component';
import { DataTableComponent } from '../../components/shared/data-table/data-table.component';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ClientsService } from '../../services/clients.service';
import { AuthService } from '../../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import {
  DashboardParameterObjectItem,
  DashboardParameterObjectsModalComponent
} from '../dashboard-parameter-objects-modal.component';


@Component({
  selector: 'app-list-board',
  standalone: true,
  imports: [MainHeaderComponent, DataTableComponent, RouterLink, MatButtonModule, CommonModule, MatFormFieldModule, TableModule],
  templateUrl: './list-board.component.html',
  styleUrl: './list-board.component.scss'
})
export class ListBoardComponent {
  dashboards$!: Observable<Dashboards[]>;
  selected!: Dashboards[];
  products!: Dashboards[];
  selectedProducts: Dashboards[] = [];
  selectedItems: any[] = [];
  dashboards: Dashboards[] = [];
  boardsData: any[] = []

  dataToDisplayInTable: any[] = [];
  columns: any[] = [
    { field: 'client_id', header: 'Cliente', filter: true, orderby: true },
    { field: 'clientName', header: 'Nombre Cliente', filter: true, orderby: false },
    { field: 'name', header: 'Tablero', filter: true, orderby: false },
    { field: 'roles', header: 'Usuarios', filter: true, orderby: false },
    { field: 'parameters_assigned', header: 'Parametros asignados', filter: true, orderby: false },
    { field: 'urlBi', header: 'Url', filter: true, orderby: false },
  ];

  @ViewChild('dt') table!: Table;
  current_user_data: any = null;

  constructor(
    public dashboardService: DashboardsService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private clientService: ClientsService,
    private authService: AuthService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    // Carga dashboards y enriquece cada fila con el nombre del cliente.
    this.dashboardService.loadDashboardsStore();

    this.authService.userData$.subscribe((user) => {
      this.current_user_data = user;
    });

    // Un solo GET a /clients: el nombre se resuelve en memoria en lugar de
    // pedir /clients/:id una vez por fila.
    const clientNames$ = this.clientService.loadClients().pipe(
      map((response: any) => new Map<number, string>(
        (response?.data ?? []).map((client: any) => [Number(client.client_id), String(client.name ?? '')])
      )),
      catchError(() => of(new Map<number, string>())),
      shareReplay({ bufferSize: 1, refCount: true })
    );

    combineLatest([this.dashboardService.dashboards$, clientNames$]).pipe(
      map(([boards, clientNames]) => boards.map(board => ({
        ...board,
        roles: this.formatRoles(board.roles ?? {}),
        parameters_assigned: this.formatParameterObjects(board.parameters_objects ?? {}),
        clientName: clientNames.get(Number(board.client_id)) || 'Cliente no encontrado'
      })))
    ).subscribe(result => {
      this.boardsData = result;
    });
  }

  onSelectionChange(event: any) {
    // Guarda la selección actual de filas.
    console.log('event', event)
    this.selectedProducts = event
  }
  onEditItem(item: any) {
    // Navega al dashboard para editarlo.
    console.log('onEditItem items:', item);
    this.router.navigate(['/dashboards', item.dashboard_id]);
  }

  get canManageParameterObjects(): boolean {
    // Permite ver el ícono de configuración solo a admin y superAdmin.
    const roles = this.current_user_data?.roles ?? {};
    return Boolean(roles.admin || roles.superadmin);
  }

  openParameterObjectsModal(item: any): void {
    // Abre el modal para editar parameters_objects y guarda el resultado.
    if (!this.canManageParameterObjects || !item?.dashboard_id) {
      return;
    }

    const dialogRef = this.dialog.open(DashboardParameterObjectsModalComponent, {
      width: '920px',
      maxWidth: '96vw',
      panelClass: 'parameter-objects-modal-panel',
      data: {
        dashboard_name: item?.name ?? 'Dashboard',
        parameters_objects: item?.parameters_objects ?? {}
      }
    });

    dialogRef.afterClosed().subscribe((result?: Record<string, DashboardParameterObjectItem>) => {
      if (!result) {
        return;
      }

      this.dashboardService.updateDashboard({ parameters_objects: result }, item.dashboard_id).subscribe({
        next: () => {
          this._snackBar.open('parameters_objects actualizados.', 'ok');
          this.dashboardService.loadDashboardsStore();
        },
        error: () => this._snackBar.open('No se pudieron guardar los parameters_objects.', 'cerrar')
      });
    });
  }

  onDeleteItems(items: any) {
    // Elimina un dashboard desde la tabla.
    console.log('Delete items:', items);
    if (window.confirm('Esto eliminar� este tablero y todas sus configuraciones')) {
      this.dashboardService.deleteDashboards(items.uid).subscribe(() => {
        this.selectedProducts = []
        console.log('Tablero delete')
        this._snackBar.open(`Tablero ${items.uid} eliminado.`, 'ok');
        this.dashboardService.loadDashboardsStore()
      })
    }
  }

  deleteDashboard(dashboard: Dashboards[]) {
    // Elimina varios dashboards seleccionados.
    this._snackBar.open('Eliminando...', 'ok');
    if (window.confirm('Esto eliminar� este tablero y todas sus configuraciones')) {
      dashboard.map(dashboard => {
        if (dashboard.dashboard_id) { // Verifica si el usuario tiene uid
          this.dashboardService.deleteDashboards(dashboard.dashboard_id).subscribe(() => {
            this.selectedProducts = [];
            this._snackBar.open(`Tablero ${dashboard.name} eliminado.`, 'ok');
            this.dashboardService.loadDashboardsStore(); // Recargar la lista de usuarios
          });
        } else {
          console.error(`El dashboard ${dashboard.name} no tiene un uid v�lido`);
        }
      });
    }
  }

  onRowSelect(event: any) {
    // Registra la fila seleccionada.
    console.log('select', this.selectedProducts)
  }

  formatRoles(roles: any): string {
    // Convierte el objeto de roles a texto legible.
    if (!roles) return 'Sin roles';
    const enabledRoles = Object.keys(roles).filter(emails => roles[emails]);
    return enabledRoles.length ? enabledRoles.join(', ') : 'Sin roles';
  }

  formatParameterObjects(parameters_objects: Record<string, { label?: string }>): string {
    // Muestra solo las labels configuradas en cada dashboard.
    const labels = Object.values(parameters_objects ?? {})
      .map((item) => String(item?.label ?? '').trim())
      .filter((label) => label.length > 0);

    return labels.length ? labels.join(', ') : 'Sin parametros';
  }
}
